export { default as Home } from '@App/bundles/home/components/home/homeContainer';
export {default as HomePhoto} from '@App/bundles/home/components/home/homePhoto/homePhoto';


// WEBPACK FOOTER //
// ./src/bundles/home/components/index.ts